import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Subject } from "rxjs";
import { CigarFilter } from "../models/cigar.filter";
import { sortFilterType } from '../enums/cigarsortfilter_type';

@Injectable({
  providedIn: 'root'
})
export class CigarselectorService {
  private cigarFilter: CigarFilter = {
    duration: { min: 0, max: 120 },
    price: { min: 0, max: 2000 },
    ripingTime: 0,
    strength: null,
    rating: 0,
    fittingDrink: null,
    format: "",
    fittingAromas: null,
    nameorigin: "",
    sort: sortFilterType.sortname_asc
  };
  private filter = new Subject<CigarFilter>();


  constructor() {

  }
  /**
   * Setzt ein Attribut am Zigarrenfilter
   * @param name
   * @param value
   */
  public async setAttribute(name: string, value?: any): Promise<void> {
    console.log("cigarselector.service setting attribute");
    console.log(name);
    console.log(value);
    switch (name) {
      case "duration":
        this.cigarFilter.duration.min = value.min;
        this.cigarFilter.duration.max = value.max;
        break;
      case "price":
        this.cigarFilter.price.min = value.min;
        this.cigarFilter.price.max = value.max;
        break;
      case "strength":
        this.cigarFilter.strength = value;
        break;
      case "ripingtime":
        this.cigarFilter.ripingTime = value;
        break;
      case "rating":
        this.cigarFilter.rating = value;
        break
      case "fitting_drink":
        this.cigarFilter.fittingDrink = value;
        break;
      case "aromas":
        this.cigarFilter.fittingAromas = value;
        break;
      case "nameorigin":
        this.cigarFilter.nameorigin = value;
        break;
      case "name_asc":
        this.cigarFilter.sort = sortFilterType.sortname_asc;
        break;
      case "name_desc":
        this.cigarFilter.sort = sortFilterType.sortname_desc;
        break;
      case "price_asc":
        this.cigarFilter.sort = sortFilterType.sortprice_asc;
        break;
      case "price_desc":
        this.cigarFilter.sort = sortFilterType.sortprice_desc;
        break;
      case "size_asc":
        this.cigarFilter.sort = sortFilterType.sortsize_asc;
        break;
      case "size_desc":
        this.cigarFilter.sort = sortFilterType.sortsize_desc;
        break;
      case "amount_asc":
        this.cigarFilter.sort = sortFilterType.sortamount_asc;
        break;
      case "amount_desc":
        this.cigarFilter.sort = sortFilterType.sortamount_desc;
        break;
      case "date_asc":
        this.cigarFilter.sort = sortFilterType.sortdate_asc;
        break;
      case "date_desc":
        this.cigarFilter.sort = sortFilterType.sortdate_desc;
        break;
    }
    this.filter.next(this.cigarFilter);

  }
  /**
   * Gibt kompletten Zigarrenfilter als Observable zurück
   *
   */
  public getFilter() {

    return this.filter.asObservable();
  }

}
